import {ArrowRight} from 'lucide-react';
import GradientContainer from '../GradientContainer';

export default function ProfilingCTA() {
  return (
    <GradientContainer className="p-6 h-auto lg:h-[200px]">
      <div className="relative flex flex-col gap-6 md:flex-row md:items-center md:justify-between h-full">
        <div className="space-y-4 md:max-w-[70%]">
          <h3 className="text-lg font-semibold md:text-2xl text-white !mt-0">
            Fast track to Continuous Profiling
          </h3>
          <p className="text-muted-foreground text-sm md:text-base text-white">
            Request extending your trial period to 30 days and an opportunity to learn from Polar
            Signals experts on a 2 hours tailored hands-on workshop for free.
          </p>
        </div>
        <div className="flex-shrink-0">
          <a
            href="https://events.polarsignals.com/getting-started-with-continuous-profiling"
            target="_blank"
            rel="noopener noreferrer"
            className="group/button rounded flex flex-row justify-center items-center gap-2 bg-white px-4 py-3 font-sans text-base font-medium text-gray-700 first-line:text-center hover:opacity-90 lg:py-4 lg:text-lg no-underline transition-all duration-300"
          >
            Register now
            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover/button:translate-x-1" />
          </a>
        </div>
      </div>
    </GradientContainer>
  );
}
